import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {NestedTreeControl} from '@angular/cdk/tree';

@Component({
  selector: 'app-modal-gdv-receipt',
  templateUrl: './modal-gdv-receipt.component.html',
  styles: []
})
export class ModalGdvReceiptComponent extends ExcTranslation implements OnInit {
  @Input() data: {
    action: any;
    caseID: string;
    attachmentJagData?: any[];
  } = {
    caseID: '',
    action: null,
    attachmentJagData: []
  };

  // typ 15/90
  selectedTerminType = 'typ15';
  terminDate = '';
  terminTime = '';
  terminNote = '';

  // typ 11/12
  ConfigAttachmentTable = {
    treeControl: new NestedTreeControl<any>(node => node.documents),
    dataSource: [] as any[],
    hasChild: (_: number, node: any) => !!node.documents && node.documents.length > 0
  };
  attachmentList = {
    selectKey: 'dokID',
    selected: [] as any[],
    selectedObjects: [] as any[]
  };

  showTerminInputs = false;
  showAttachmentInput = false;
  showWarningTyp11 = false;

  constructor(
    public modal: ExgModalService,
    private excRest: ExcRestService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    const type = this.data.action.quittungType;
    this.showTerminInputs = type === '15' || type === '90';
    this.showAttachmentInput = type === '11' || type === '12';
    this.showWarningTyp11 = type === '11';

    if (this.showAttachmentInput && this.data.attachmentJagData) {
      this.ConfigAttachmentTable.dataSource = this.data.attachmentJagData;
    }
  }

  isSelected(node: any): boolean {
    return this.attachmentList.selected.includes(node.dokID);
  }

  toggleSelection(node: any): void {
    const index = this.attachmentList.selected.indexOf(node.dokID);
    if (index > -1) {
      this.attachmentList.selected.splice(index, 1);
      const objIndex = this.attachmentList.selectedObjects.findIndex(obj => obj.dokID === node.dokID);
      if (objIndex > -1) {
        this.attachmentList.selectedObjects.splice(objIndex, 1);
      }
    } else {
      this.attachmentList.selected.push(node.dokID);
      this.attachmentList.selectedObjects.push(node);
    }
  }

  canSend(): boolean {
    const type = this.data.action.quittungType;

    if (type === '15' || type === '90') {
      if (this.selectedTerminType === 'typ15') {
        return this.terminDate.length > 0 && this.terminTime.length > 0;
      } else {
        return this.terminNote.trim().length >= 5;
      }
    }

    return true;
  }

  clickedSend(): void {
    if (!this.canSend()) {
      this.modal.showToast(
        'Füllen Sie alle Pflichtfelder aus',
        'md-toast',
        'fas fa-exclamation'
      );
      return;
    }

    const payload: any = {
      quittungType: this.data.action.quittungType
    };

    if (this.data.action.quittungType === '15' || this.data.action.quittungType === '90') {
      if (this.selectedTerminType === 'typ15') {
        payload.quittungType = '15';
        payload.notiz = `${this.terminDate} ${this.terminTime}`;
      } else {
        payload.quittungType = '90';
        payload.mitteilung = this.terminNote;
      }
    }

    if (this.attachmentList.selected.length > 0) {
      payload.attachmentIDs = JSON.stringify(this.attachmentList.selected);
    }

    this.excRest
      .post(
        this.excRest.computeUrl('GDVReceiptC', { auID: this.data.caseID }),
        payload
      )
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.modal.showToast(
              'GDV  Quittung erfolgreich versendet',
              'md-toast bg-green',
              'fal fa-check-circle'
            );
            this.modal.action({
              success: true,
              quittungType: payload.quittungType
            });
            this.modal.close();
          } else {
            this.modal.showToast(
              'Fehler beim Versand',
              'md-toast bg-red',
              'fal fa-times-circle'
            );
          }
        }
      );
  }

  getModalMinHeight(): string {
    return this.showWarningTyp11 ? '30rem' : 'auto';
  }

  close(): void {
    this.modal.close();
  }
}
